import * as yup from 'yup';

export const auslandsreisekrankenversicherungOptionenSchema = yup.object({
  ruecktransportAusland: yup.boolean().default(false),
});
